import { Outlet } from "react-router-dom";
import { Sidebar } from "@/layouts/components/Sidebar";
import { TopBar } from "@/layouts/components/TopBar";
import { MobileNav } from "@/layouts/components/MobileNav";
import { AppLinkNotice } from "@/shared/components/feedback/AppLinkNotice";

export const AppLayout = () => {
  return (
    <div className="flex flex-col md:flex-row h-[100dvh] bg-gray-50">
      {/* Incoming calls are now handled by ActiveCallProvider (above the router) */}

      {/* Sidebar - hidden on mobile */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <TopBar />
        <main className="flex-1 overflow-y-auto p-3 pb-20 md:p-6 md:pb-6">
          <Outlet />
        </main>
      </div>

      {/* Bottom tab bar for mobile */}
      <MobileNav />

      <AppLinkNotice />
    </div>
  );
};
